import { render, staticRenderFns } from "./DownloadCustomersButton.vue?vue&type=template&id=3cabd8f0"
import script from "./DownloadCustomersButton.vue?vue&type=script&lang=js"
export * from "./DownloadCustomersButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports